export enum HMSTrackExceptionTrackType {
  AUDIO = 'audio',
  VIDEO = 'video',
  AUDIO_VIDEO = 'audio, video',
  SCREEN = 'screen',
}
